import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  children?: ReactNode;
}

export default function LeaveApplicationsHeader({ children }: Props) {
  const { t } = useTranslation("LeaveApplicationsPage");

  return (
    <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("header.title")}</h1>
      {children}
    </div>
  );
}

